import * as tslib_1 from "tslib";
import store from '../store/store';
import { updateUserConfiguration } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(action('saveReplyOption')(function saveReplyOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.IsReplyAllTheDefaultResponse = optionState.replyAllByDefault;
                    return [4 /*yield*/, updateUserConfiguration([
                            {
                                propertyName: 'IsReplyAllTheDefaultResponse',
                                propertyType: 'Boolean',
                                propertyValue: "" + optionState.replyAllByDefault,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveReplyOption.js.map